export const range = (start: number, stop: number, step: number = 1) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => (start + (i * step)).toString());

export interface VrmValidateClaim {
    claimId: string;
    companyName: string;
    peridFrom?: Date;
    imagesCount: number;
}

export interface VrmValidateData {
    vrm: string;
    vcm: string;
    claims: VrmValidateClaim[];
}